import { render, staticRenderFns } from "./LmTableCustom.vue?vue&type=template&id=bef8ed96&scoped=true"
import script from "./LmTableCustom.vue?vue&type=script&lang=js"
export * from "./LmTableCustom.vue?vue&type=script&lang=js"
import style0 from "./LmTableCustom.vue?vue&type=style&index=0&id=bef8ed96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef8ed96",
  null
  
)

export default component.exports